import { Reveal } from "./Reveal";
import { Droplets, Gem, Hourglass } from "lucide-react";
import { useLang } from "../i18n";

export const Manifesto = () => {
    const { t } = useLang();
    const CHAPTERS = [
        { n: "01", icon: Droplets, title: t("manifesto.c1t"), text: t("manifesto.c1x") },
        { n: "02", icon: Gem, title: t("manifesto.c2t"), text: t("manifesto.c2x") },
        { n: "03", icon: Hourglass, title: t("manifesto.c3t"), text: t("manifesto.c3x") },
    ];
    return (
        <section id="story" className="relative py-28 sm:py-40 px-6 sm:px-10" data-testid="manifesto-section">
            <div className="max-w-7xl mx-auto">
                <Reveal>
                    <p className="text-xs tracking-[0.3em] uppercase text-golddark mb-6">{t("manifesto.overline")}</p>
                </Reveal>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-end mb-24 sm:mb-36">
                    <Reveal delay={0.1}>
                        <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight text-charcoal" data-testid="manifesto-heading">
                            {t("manifesto.headingA")}
                            <em className="text-golddark">{t("manifesto.headingB")}</em>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p className="text-smoke text-base leading-relaxed max-w-lg">{t("manifesto.body")}</p>
                    </Reveal>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-gold/25 border border-gold/25">
                    {CHAPTERS.map((c, i) => (
                        <Reveal key={c.n} delay={i * 0.15} className="bg-ivory">
                            <div className="p-10 sm:p-14 h-full flex flex-col" data-testid={`manifesto-chapter-${c.n}`}>
                                <div className="flex items-start justify-between mb-14">
                                    <span className="font-serif text-5xl text-gold/60">{c.n}</span>
                                    <c.icon size={22} strokeWidth={1.25} className="text-golddark mt-2" />
                                </div>
                                <h3 className="font-serif text-2xl sm:text-3xl tracking-tight text-charcoal mb-4">{c.title}</h3>
                                <p className="text-sm text-smoke leading-relaxed">{c.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
